module.exports = __webpack_public_path__ + "img/Reset_Password.072608b9.png";